"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.BackendSDK = void 0;
var axios_1 = require("axios");
/**
 * @class BackendSDK
 *
 * @category Backend
 * @param {string}authToken - Auth Token
 * @param {string}rootURL - Backend URL without trailing `/`
 * @param {function}getAuthToken - Function that return Auth Token.
 * @summary Class to connect to backend by providing following params.
- Note: <span style="color:blue"> You will not instantiate BackendSDK every time you want to call backend.
 Mostly you will call `new BackendSDK()` once in file and
then export the object `bSDK` and use that everywhere. In frontend `bSdk` is already available.
</span>.
 * @example
// import
import { bSdk } from "services/BackendSDKService";

// Call CMS Query
let result = await bSdk.cmsQuery(
  "master-client",
  {},
  {
    route: "/",
    method: "get",
    authToken: AuthServices.getToken(),
    include: ["DBA", "CorporationName"],
    query: { pageSize: 0, page: 0, sort: "DBA", sortOrder: "asc" },
  }
);

// Call custom api function(rpc)
let result = await bSdk.SubClient_SubClientUpdateContactInformation({
  ...
})
 */
var BackendSDK = /** @class */ (function () {
    function BackendSDK(io) {
        this.rootURL = io.rootURL;
        if (io.authToken)
            this.authToken = io.authToken;
        this.getAuthToken = io.getAuthToken;
    }
    BackendSDK.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.getAuthToken)
                    return [2 /*return*/, this.getAuthToken()];
                return [2 /*return*/, this.authToken];
            });
        });
    };
    /**
     *
     * @param {string} collectionKey -  The collection key e.g. `sub-client`
     * @param {Object} options - Refer ICMSQueryOptions
     * @returns {Array} Array of object
     * @summary List Documents for collection. It support pagination, sorting, searching, projection
     * @example
  // Return all records from document-type
  let result = await bSdk.cmsList("document-type", {
    query: { pageSize: 0, page: 0 }, // This means all records
  });
  
  // Apply Filtering records.
  let result = await bSdk.cmsList("tax-filings", {
    filter: {
      Month: format(subMonths(new Date(), 1), "yyyy-MM"),
      SubClientID: props.SubClientID,
    },
  });
  
  // Projection
  let lstCounty = await bSdk.cmsList("state-county", {
    filter: { ZipCodes: zipCode },
    include: ["CountyName"], // It will only return given columns.
  });
     */
    BackendSDK.prototype.cmsList = function (collectionKey, options) {
        return __awaiter(this, void 0, void 0, function () {
            var result, _a, _b;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.cmsQuery;
                        _b = [collectionKey,
                            {}];
                        _c = { route: "/" };
                        return [4 /*yield*/, this.getToken()];
                    case 1: return [4 /*yield*/, _a.apply(this, _b.concat([__assign.apply(void 0, [(_c.authToken = _d.sent(), _c), options])]))];
                    case 2:
                        result = _d.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    /**
     *
     * @param collectionKey - The collection key e.g. `sub-client`
     * @param id - _id of mongodb document.
     * @returns {Object}
     * @summary Get single document from backend.
     * @example
     * let objSchedule = await bSdk.cmsDetail("bot-schedule", "");
     */
    BackendSDK.prototype.cmsDetail = function (collectionKey, id, options) {
        return __awaiter(this, void 0, void 0, function () {
            var result, _a, _b;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.cmsQuery;
                        _b = [collectionKey,
                            {}];
                        _c = { route: "/".concat(id) };
                        return [4 /*yield*/, this.getToken()];
                    case 1: return [4 /*yield*/, _a.apply(this, _b.concat([__assign.apply(void 0, [(_c.authToken = _d.sent(), _c), options])]))];
                    case 2:
                        result = _d.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    /**
     *
     * @param {String} collectionKey - The collection key e.g. `sub-client`
     * @param {Object} data - Object according to (collectionName)Schema
     * @summary It will create document in backend
     */
    BackendSDK.prototype.cmsCreate = function (collectionKey, data) {
        return __awaiter(this, void 0, void 0, function () {
            var result, _a, _b;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.cmsQuery;
                        _b = [collectionKey, data];
                        _c = {
                            route: "/",
                            method: "post"
                        };
                        return [4 /*yield*/, this.getToken()];
                    case 1: return [4 /*yield*/, _a.apply(this, _b.concat([(_c.authToken = _d.sent(),
                                _c)]))];
                    case 2:
                        result = _d.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    /**
     *
     * @param {String} collectionKey - The collection key e.g. `sub-client`
     * @param {Object} data - Object for updating according to (collectionName)Schema
     * @param id - _id of mongodb document.
     * @summary It will update document for given id
     */
    BackendSDK.prototype.cmsUpdate = function (collectionKey, id, data) {
        return __awaiter(this, void 0, void 0, function () {
            var result, _a, _b;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.cmsQuery;
                        _b = [collectionKey, data];
                        _c = {
                            route: "/".concat(id),
                            method: "put"
                        };
                        return [4 /*yield*/, this.getToken()];
                    case 1: return [4 /*yield*/, _a.apply(this, _b.concat([(_c.authToken = _d.sent(),
                                _c)]))];
                    case 2:
                        result = _d.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    /**
     *
     * @param {String} collectionKey - The collection key e.g. `sub-client`
     * @param id - _id of mongodb document.
     * @summary It will delete document from backend.
     */
    BackendSDK.prototype.cmsRemove = function (collectionKey, id) {
        return __awaiter(this, void 0, void 0, function () {
            var result, _a, _b;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.cmsQuery;
                        _b = [collectionKey,
                            {}];
                        _c = {
                            route: "/".concat(id),
                            method: "delete"
                        };
                        return [4 /*yield*/, this.getToken()];
                    case 1: return [4 /*yield*/, _a.apply(this, _b.concat([(_c.authToken = _d.sent(),
                                _c)]))];
                    case 2:
                        result = _d.sent();
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                }
            });
        });
    };
    BackendSDK.prototype.cancelRequest = function (requestID) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                if (globalThis["request_".concat(requestID)]) {
                    (_b = (_a = globalThis["request_".concat(requestID)]).cancel) === null || _b === void 0 ? void 0 : _b.call(_a, "Request is cancelled. ");
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     *
     * @param {String} collectionKey - The collection key e.g. `sub-client`
     * @param {Object} data - Object according to (collectionName)Schema
     * @param {Object} options - Refer ICMSQueryOptions
     * @summary Base function for all CMS function like cmsList, cmsDetail, ...
     * - You can call any backend api related to `Collection` using cmsQuery.
     * - It's almost similar to HttpClient. refer ICMSQueryOptions for more details
     */
    BackendSDK.prototype.cmsQuery = function (collectionKey, data, options) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, queryValues, url, source, responseData;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!options)
                            options = {};
                        options.headers = __assign({ "Content-Type": "application/json" }, options.headers);
                        if (!options.method) {
                            options.method = "get";
                        }
                        if (!options.route) {
                            options.route = "/";
                        }
                        if (!options.authToken) return [3 /*break*/, 1];
                        options.headers.Authorization = options.authToken;
                        return [3 /*break*/, 3];
                    case 1:
                        if (!(options.noAuthToken !== false)) return [3 /*break*/, 3];
                        _b = options.headers;
                        return [4 /*yield*/, this.getToken()];
                    case 2:
                        _b.Authorization = _c.sent();
                        _c.label = 3;
                    case 3:
                        queryValues = "";
                        if (options.query) {
                            queryValues = Object.keys(options.query)
                                .map(function (key) { return "".concat(key, "=").concat(((options === null || options === void 0 ? void 0 : options.query) || {})[key]); })
                                .join("&");
                        }
                        if (options.filter) {
                            queryValues += "&filter=".concat(JSON.stringify(options.filter));
                        }
                        if (options.include) {
                            queryValues += "&include=".concat(options.include);
                        }
                        if (options.exclude) {
                            queryValues += "&exclude=".concat(options.exclude);
                        }
                        if (options.search) {
                            queryValues += "&search=".concat(options.search);
                        }
                        url = "".concat(this.rootURL, "/api/").concat(collectionKey).concat(options.route, "?").concat(queryValues);
                        if (options.requestID) {
                            if (globalThis["request_".concat(options.requestID)]) {
                                this.cancelRequest(options.requestID);
                            }
                            source = axios_1["default"].CancelToken.source();
                            globalThis["request_".concat(options.requestID)] = source;
                        }
                        return [4 /*yield*/, (0, axios_1["default"])({
                                url: url,
                                headers: options.headers,
                                method: options.method.toUpperCase(),
                                data: JSON.stringify(data),
                                cancelToken: (_a = globalThis["request_".concat(options.requestID)]) === null || _a === void 0 ? void 0 : _a.token
                            })];
                    case 4:
                        responseData = _c.sent();
                        if (options.requestID) {
                            delete globalThis["request_".concat(options.requestID)];
                        }
                        return [2 /*return*/, responseData === null || responseData === void 0 ? void 0 : responseData.data];
                }
            });
        });
    };
    // Methods Start
    BackendSDK.prototype.SystemUsers_SendUserCreationEmail = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("system-users", args, { method: "post", route: "/SendUserCreationEmail" })];
            });
        });
    };
    BackendSDK.prototype.SystemUsers_UpdateSystemUserActiveStatus = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("system-users", args, { method: "post", route: "/UpdateSystemUserActiveStatus" })];
            });
        });
    };
    BackendSDK.prototype.SystemUsers_GetOnlineUsers = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("system-users", args, { method: "post", route: "/GetOnlineUsers" })];
            });
        });
    };
    BackendSDK.prototype.SystemUsers_UpdatePreferences = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("system-users", args, { method: "post", route: "/UpdatePreferences" })];
            });
        });
    };
    BackendSDK.prototype.SystemUsers_ViewPassword = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("system-users", args, { method: "post", route: "/viewPassword" })];
            });
        });
    };
    BackendSDK.prototype.Auth_UpdateAccountSettings = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("auth", args, { method: "post", route: "/UpdateAccountSettings" })];
            });
        });
    };
    BackendSDK.prototype.Auth_GetTFALoginInfoFromLink = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("auth", args, { method: "post", route: "/GetTFALoginInfoFromLink" })];
            });
        });
    };
    BackendSDK.prototype.Auth_AcceptTFALoginFromTheLink = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("auth", args, { method: "post", route: "/AcceptTFALoginFromTheLink" })];
            });
        });
    };
    BackendSDK.prototype.Auth_ConfirmResetPassword = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("auth", args, { method: "post", route: "/ConfirmResetPassword" })];
            });
        });
    };
    BackendSDK.prototype.Auth_SendResetPasswordLink = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("auth", args, { method: "post", route: "/SendResetPasswordLink" })];
            });
        });
    };
    BackendSDK.prototype.Auth_ChangeAccountInformation = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("auth", args, { method: "post", route: "/ChangeAccountInformation" })];
            });
        });
    };
    BackendSDK.prototype.Auth_ChangePassword = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("auth", args, { method: "post", route: "/ChangePassword" })];
            });
        });
    };
    BackendSDK.prototype.Auth_SendTFAOTP = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("auth", args, { method: "post", route: "/SendTFAOTP" })];
            });
        });
    };
    BackendSDK.prototype.Auth_VerifyTFAOTP = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("auth", args, { method: "post", route: "/VerifyTFAOTP" })];
            });
        });
    };
    BackendSDK.prototype.Auth_Login = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("auth", args, { method: "post", route: "/login" })];
            });
        });
    };
    BackendSDK.prototype.Auth_GetUserInfo = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("auth", args, { method: "post", route: "/getUserInfo" })];
            });
        });
    };
    BackendSDK.prototype.Auth_ResetPassword = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("auth", args, { method: "post", route: "/reset-password" })];
            });
        });
    };
    BackendSDK.prototype.Auth_GetPermanentToken = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("auth", args, { method: "post", route: "/getPermanentToken" })];
            });
        });
    };
    BackendSDK.prototype.MasterClient_GetDownloaderExeLink = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("master-client", args, { method: "post", route: "/GetDownloaderExeLink" })];
            });
        });
    };
    BackendSDK.prototype.MasterClient_UploadDownloaderExe = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("master-client", args, { method: "post", route: "/UploadDownloaderExe" })];
            });
        });
    };
    BackendSDK.prototype.MasterClient_GetDownloaderInfo = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("master-client", args, { method: "post", route: "/GetDownloaderInfo" })];
            });
        });
    };
    BackendSDK.prototype.MasterClient_UploadDownloaderVersion = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("master-client", args, { method: "post", route: "/UploadDownloaderVersion" })];
            });
        });
    };
    BackendSDK.prototype.MasterClient_GetLatestVersionOfDownlaoder = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("master-client", args, { method: "post", route: "/GetLatestVersionOfDownlaoder" })];
            });
        });
    };
    BackendSDK.prototype.MasterClient_GetDocumentDownloaderAuthToken = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("master-client", args, { method: "post", route: "/GetDocumentDownloaderAuthToken" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_RunDownloadMonthlyReportBot = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/RunDownloadMonthlyReportBot" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_UpdateRevenueReminderBulk = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/UpdateRevenueReminderBulk" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_UpdateRevenueReminder = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/UpdateRevenueReminder" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_UpdateSubClientBulk = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/UpdateSubClientBulk" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_GetSubClientSummary = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/GetSubClientSummary" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_FetchSubClientReminders = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/FetchSubClientReminders" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_RunTourismTaxPasswordChangeBot = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/RunTourismTaxPasswordChangeBot" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_ModifyClientGroup = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/ModifyClientGroup" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_GetClientGroupDetail = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/GetClientGroupDetail" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_CreateNewClientGroup = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/CreateNewClientGroup" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_GetSubClientAutoCompleteList = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/GetSubClientAutoCompleteList" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_CheckForTaxFilingNotCreated = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/CheckForTaxFilingNotCreated" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_RunFranchiseInvoiceBot = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/RunFranchiseInvoiceBot" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_UpdateFranchiseInvoiceDetail = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/UpdateFranchiseInvoiceDetail" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_RemoveLoadingJobForBankDetails = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/RemoveLoadingJobForBankDetails" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_UpdateCredentials = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/UpdateCredentials" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_BotUpdateContactInfoOnState = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/BotUpdateContactInfoOnState" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_UpdateSignatureInfoFromMasterClient = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/UpdateSignatureInfoFromMasterClient" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_BotReconcileContactInfoWithState = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/BotReconcileContactInfoWithState" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_CreateSubClientUser = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/CreateSubClientUser" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_ExecuteBotToUpdateBankInformationOnCounty = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/ExecuteBotToUpdateBankInformationOnCounty" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_ExecuteBotToUpdateBankInformationOnState = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/ExecuteBotToUpdateBankInformationOnState" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SubClientCreateLogForBankDetailReconcileBot = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/SubClientCreateLogForBankDetailReconcileBot" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SubClientUploadBankDocuments = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/SubClientUploadBankDocuments" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SubClientUpdateDownloaderConfigPath = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/SubClientUpdateDownloaderConfigPath" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SubClientBatchUpdateStageSkipConfiguration = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/SubClientBatchUpdateStageSkipConfiguration" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SubClientUpdateActivationStatus = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/SubClientUpdateActivationStatus" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SubClientGetTaxWebsiteURLWithCredentials = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/SubClientGetTaxWebsiteURLWithCredentials" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SubClientGetEligibleForDelete = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/SubClientGetEligibleForDelete" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SubClientUpdateConfiguration = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/SubClientUpdateConfiguration" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SubClientUpdateTourismTax = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/SubClientUpdateTourismTax" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SubClientUpdateBankInformation = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/SubClientUpdateBankInformation" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SubClientUpdateContactInformation = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/SubClientUpdateContactInformation" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SubClientUpdateBasicInformation = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/SubClientUpdateBasicInformation" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SubClientDecryptInformation = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/SubClientDecryptInformation" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_CreateClientBotLog = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/createClientBotLog" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_CreateTourismExtractBotLog = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/createTourismExtractBotLog" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_CreateSalesTaxExtractBotLog = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/createSalesTaxExtractBotLog" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_SendRevenueReminder = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/sendRevenueReminder" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_ValidateBulkClient = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/validateBulkClient" })];
            });
        });
    };
    BackendSDK.prototype.SubClient_InsertBulk = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("sub-client", args, { method: "post", route: "/insertBulk" })];
            });
        });
    };
    BackendSDK.prototype.State_GetSubClientState = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("state", args, { method: "post", route: "/getSubClientState" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_SyncGroupStatus = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/SyncGroupStatus" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_ApplyEstimateTaxFromPreviousMonth = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/ApplyEstimateTaxFromPreviousMonth" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_UpdateTaxFilingViaSubmissionForm = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/UpdateTaxFilingViaSubmissionForm" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_GetTaxFilingSummary = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/GetTaxFilingSummary" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_UploadRevenueFiles = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/UploadRevenueFiles" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_UploadDocumentsToFiling = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/UploadDocumentsToFiling" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_UnlockRevenueSubmissionFromClient = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/UnlockRevenueSubmissionFromClient" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_GetRevenueSubmissionLink = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/GetRevenueSubmissionLink" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_OverrideCollectionAllowance = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/OverrideCollectionAllowance" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_StartTourismTaxConfirmationDownloadBot = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/StartTourismTaxConfirmationDownloadBot" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_AcceptBankInfoMissMatch = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/AcceptBankInfoMissMatch" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_AcceptBankInfoMissMatchForTourism = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/AcceptBankInfoMissMatchForTourism" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_StartSalesTaxConfirmationDownloadBot = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/StartSalesTaxConfirmationDownloadBot" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_CreateBotForAppfolioTaxPaymentEntry = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/CreateBotForAppfolioTaxPaymentEntry" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_UpgradeTaxFilingToV2 = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/UpgradeTaxFilingToV2" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_SyncTaxFilingBasicInfoSalesTaxTourismTax = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/SyncTaxFilingBasicInfoSalesTaxTourismTax" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_MakeSalesTaxFilingEditable = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/MakeSalesTaxFilingEditable" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_UpdateSalesTaxRevenue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/UpdateSalesTaxRevenue" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_TaxFilingsFindSalesTaxFilingMismatch = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/TaxFilingsFindSalesTaxFilingMismatch" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_TaxFilingsDeleteOfSubClientForCurrentMonth = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/TaxFilingsDeleteOfSubClientForCurrentMonth" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_TaxFilingsGetEligibleForDelete = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/TaxFilingsGetEligibleForDelete" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_TaxFilingsCountOnCountyChange = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/TaxFilingsCountOnCountyChange" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_TaxFilingsLastMonthCount = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/TaxFilingsLastMonthCount" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_AcceptReview = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/acceptReview" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_AcceptTourismTaxReviews = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/acceptTourismTaxReviews" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_StartTaxFiling = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/startTaxFiling" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_StartTourismTaxFiling = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/startTourismTaxFiling" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_CreateTaxFillingForLastMonth = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/createTaxFillingForLastMonth" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_UpdateBatch = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/updateBatch" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_ApproveBatch = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/approveBatch" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_ApproveTourismBatch = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/approveTourismBatch" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_ChangeTaxFilingStatus = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/changeTaxFilingStatus" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_ChangeTourismTaxFilingStatus = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/changeTourismTaxFilingStatus" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_AddOrUpdateTourismTaxRevenueFromReceipts = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/addOrUpdateTourismTaxRevenueFromReceipts" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_AddOrUpdateSalesTaxRevenueFromReceipts = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/addOrUpdateSalesTaxRevenueFromReceipts" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_GetTourismTaxRevenue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/getTourismTaxRevenue" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_CalculateTourismTaxRevenue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/calculateTourismTaxRevenue" })];
            });
        });
    };
    BackendSDK.prototype.TaxFilings_UpdateTourismTaxRevenue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("tax-filings", args, { method: "post", route: "/updateTourismTaxRevenue" })];
            });
        });
    };
    BackendSDK.prototype.DocumentRepository_CRPCDownloaderClient = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("document-repository", args, { method: "post", route: "/CRPCDownloaderClient" })];
            });
        });
    };
    BackendSDK.prototype.DocumentRepository_GetDownloaderLogDetail = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("document-repository", args, { method: "post", route: "/GetDownloaderLogDetail" })];
            });
        });
    };
    BackendSDK.prototype.DocumentRepository_GetLogsOfDownloader = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("document-repository", args, { method: "post", route: "/GetLogsOfDownloader" })];
            });
        });
    };
    BackendSDK.prototype.DocumentRepository_GetFilesOfDownloader = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("document-repository", args, { method: "post", route: "/GetFilesOfDownloader" })];
            });
        });
    };
    BackendSDK.prototype.DocumentRepository_GetConnectedDownloaderList = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("document-repository", args, { method: "post", route: "/GetConnectedDownloaderList" })];
            });
        });
    };
    BackendSDK.prototype.DocumentRepository_GetDocumentForSyncing = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("document-repository", args, { method: "post", route: "/GetDocumentForSyncing" })];
            });
        });
    };
    BackendSDK.prototype.DocumentRepository_GetMultipleDecryptedFile = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("document-repository", args, { method: "post", route: "/getMultipleDecryptedFile" })];
            });
        });
    };
    BackendSDK.prototype.MessageTemplate_Test = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("message-template", args, { method: "post", route: "/test" })];
            });
        });
    };
    BackendSDK.prototype.MessageLog_MarkEmailRead = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("message-log", args, { method: "post", route: "/MarkEmailRead" })];
            });
        });
    };
    BackendSDK.prototype.MessageLog_GetMessageLogListForMasterClient = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("message-log", args, { method: "post", route: "/GetMessageLogListForMasterClient" })];
            });
        });
    };
    BackendSDK.prototype.BotSchedule_RunBotSchedule = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("bot-schedule", args, { method: "post", route: "/RunBotSchedule" })];
            });
        });
    };
    BackendSDK.prototype.BotLog_RetryBotLog = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("bot-log", args, { method: "post", route: "/RetryBotLog" })];
            });
        });
    };
    BackendSDK.prototype.BotLog_ChangeStatus = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("bot-log", args, { method: "post", route: "/changeStatus" })];
            });
        });
    };
    BackendSDK.prototype.BotLog_GetBotLogSummary = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("bot-log", args, { method: "post", route: "/getBotLogSummary" })];
            });
        });
    };
    BackendSDK.prototype.StateCounty_StateCountyUpdateImmediatePaymentDeduction = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("state-county", args, { method: "post", route: "/StateCountyUpdateImmediatePaymentDeduction" })];
            });
        });
    };
    BackendSDK.prototype.StateCounty_GetStateCounty = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("state-county", args, { method: "post", route: "/getStateCounty" })];
            });
        });
    };
    BackendSDK.prototype.CronLog_RunCronJob = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("cron-log", args, { method: "post", route: "/runCronJob" })];
            });
        });
    };
    BackendSDK.prototype.Bookmark_UpdateBookmarkOrder = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("bookmark", args, { method: "post", route: "/updateBookmarkOrder" })];
            });
        });
    };
    BackendSDK.prototype.ActionLog_CreateActionLog = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("action-log", args, { method: "post", route: "/createActionLog" })];
            });
        });
    };
    BackendSDK.prototype.DynamicReportView_GetDynamicReportData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("dynamic-report-view", args, { method: "post", route: "/GetDynamicReportData" })];
            });
        });
    };
    BackendSDK.prototype.PdfParser_ParseDocument = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("pdf-parser", args, { method: "post", route: "/ParseDocument" })];
            });
        });
    };
    BackendSDK.prototype.PdfParser_ParsePDF = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("pdf-parser", args, { method: "post", route: "/parsePDF" })];
            });
        });
    };
    BackendSDK.prototype.PdfParser_ParseRevenuePDF = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("pdf-parser", args, { method: "post", route: "/parseRevenuePDF" })];
            });
        });
    };
    BackendSDK.prototype.PdfParser_TestFloridaReceiptParser = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("pdf-parser", args, { method: "post", route: "/testFloridaReceiptParser" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M25MigrateDynamicReportFilterByColumn = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M25MigrateDynamicReportFilterByColumn" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M24AddMasterClientIDToBusinessEntityAndSubClientAccess = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M24AddMasterClientIDToBusinessEntityAndSubClientAccess" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_CreateIndexesForAllModels = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/CreateIndexesForAllModels" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M23MigrateNoteToNotesCollection = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M23MigrateNoteToNotesCollection" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M22FixDoubleEncryptionForPMSUsername = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M22FixDoubleEncryptionForPMSUsername" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M21MigrateStates = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M21MigrateStates" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M20MigrateDocumentDateFromDocumentType = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M20MigrateDocumentDateFromDocumentType" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M19MigrateUserAlertConfig = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M19MigrateUserAlertConfig" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_CalculateDBSize = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/CalculateDBSize" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M18MigrateBusinessEntityInSystemUser = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M18MigrateBusinessEntityInSystemUser" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M17AddSystemUserToUserAccessHistory = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M17AddSystemUserToUserAccessHistory" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M16AddSubClientAndMasterClientIDInMessageLog = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M16AddSubClientAndMasterClientIDInMessageLog" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M15MessageTemplateTitleMigration = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M15MessageTemplateTitleMigration" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_GetMigratorList = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/GetMigratorList" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M14CreateSubClientOwnerFromPaymentContactInfo = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M14CreateSubClientOwnerFromPaymentContactInfo" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M13VerifyDocumentFiles = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M13VerifyDocumentFiles" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M12LastDateOfFilingMigration = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M12LastDateOfFilingMigration" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M11CompareBankAccountWithLastMonthConfirmation = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M11CompareBankAccountWithLastMonthConfirmation" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_M10FetchMissingDocumentFromAHMS = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/M10FetchMissingDocumentFromAHMS" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_SyncDocumentTaxFilingIDFromReceiptID = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/SyncDocumentTaxFilingIDFromReceiptID" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_RemovePaddingFromClientInfo = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/RemovePaddingFromClientInfo" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_AmendDynamicEnumData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/AmendDynamicEnumData" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_CompareDynamicEnumData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/CompareDynamicEnumData" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_PutDynamicEnumDataToFile = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/PutDynamicEnumDataToFile" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_UpgradeAllTaxFilingsToV2Once = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/UpgradeAllTaxFilingsToV2Once" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_SyncBankNameFromRoutingNo = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/SyncBankNameFromRoutingNo" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_DbMigratorUpdateFoodAndBeverageForOldTourismTaxFilingsOneTime = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/DbMigratorUpdateFoodAndBeverageForOldTourismTaxFilingsOneTime" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_DbMigratorSyncLastDatesInTaxFilings = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/DbMigratorSyncLastDatesInTaxFilings" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_DbMigratorSyncTourismTaxAndCountyPercentagesOnce = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/DbMigratorSyncTourismTaxAndCountyPercentagesOnce" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_DbMigratorSyncAllTaxFilingBasicInfo = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/DbMigratorSyncAllTaxFilingBasicInfo" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_DbMigratorMigrateDocument = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/DbMigratorMigrateDocument" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_DbMigratorSyncGlobalSettingSchema = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/DbMigratorSyncGlobalSettingSchema" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_DbMigratorEncryptSubClient = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/DbMigratorEncryptSubClient" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_SyncTaxFilingsWithDocuments = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/syncTaxFilingsWithDocuments" })];
            });
        });
    };
    BackendSDK.prototype.DbMigrator_SyncConfirmationDocuments = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("db-migrator", args, { method: "post", route: "/syncConfirmationDocuments" })];
            });
        });
    };
    BackendSDK.prototype.NotificationInstance_MarkNotificationRead = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("notification-instance", args, { method: "post", route: "/markNotificationRead" })];
            });
        });
    };
    BackendSDK.prototype.BusinessEntity_ActivateDeactivateBusinessEntity = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("business-entity", args, { method: "post", route: "/ActivateDeactivateBusinessEntity" })];
            });
        });
    };
    BackendSDK.prototype.BusinessEntity_DeleteSystemUserFromBusinessEntity = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("business-entity", args, { method: "post", route: "/DeleteSystemUserFromBusinessEntity" })];
            });
        });
    };
    BackendSDK.prototype.BusinessEntity_UpdateSystemUserForBusinessEntity = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("business-entity", args, { method: "post", route: "/UpdateSystemUserForBusinessEntity" })];
            });
        });
    };
    BackendSDK.prototype.BusinessEntity_AddSystemUserToBusinessEntity = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("business-entity", args, { method: "post", route: "/AddSystemUserToBusinessEntity" })];
            });
        });
    };
    BackendSDK.prototype.BusinessEntity_GetWebsiteURLWithCredentials = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("business-entity", args, { method: "post", route: "/GetWebsiteURLWithCredentials" })];
            });
        });
    };
    BackendSDK.prototype.BusinessEntity_UpdateEmailConfiguration = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("business-entity", args, { method: "post", route: "/UpdateEmailConfiguration" })];
            });
        });
    };
    BackendSDK.prototype.BusinessEntity_CreateLogForDailySalesReport = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("business-entity", args, { method: "post", route: "/CreateLogForDailySalesReport" })];
            });
        });
    };
    BackendSDK.prototype.BusinessEntity_UpdateConfigurations = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("business-entity", args, { method: "post", route: "/UpdateConfigurations" })];
            });
        });
    };
    BackendSDK.prototype.BusinessEntity_CreateBotLogForImportHistoricalData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("business-entity", args, { method: "post", route: "/createBotLogForImportHistoricalData" })];
            });
        });
    };
    BackendSDK.prototype.EntitySalesSummary_UploadHistoricalData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("entity-sales-summary", args, { method: "post", route: "/UploadHistoricalData" })];
            });
        });
    };
    BackendSDK.prototype.EntitySalesSummary_GetSalesComparisonReport = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("entity-sales-summary", args, { method: "post", route: "/GetSalesComparisonReport" })];
            });
        });
    };
    BackendSDK.prototype.MiscData_GetCollectionsList = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("misc-data", args, { method: "post", route: "/GetCollectionsList" })];
            });
        });
    };
    BackendSDK.prototype.MiscData_GetBusinessTypeMapping = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("misc-data", args, { method: "post", route: "/GetBusinessTypeMapping" })];
            });
        });
    };
    BackendSDK.prototype.MiscData_SetBusinessTypeMapping = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("misc-data", args, { method: "post", route: "/SetBusinessTypeMapping" })];
            });
        });
    };
    BackendSDK.prototype.StateFilingDates_GetLastDates = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("state-filing-dates", args, { method: "post", route: "/GetLastDates" })];
            });
        });
    };
    BackendSDK.prototype.DocumentHistories_GetFieldHistory = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("document-histories", args, { method: "post", route: "/GetFieldHistory" })];
            });
        });
    };
    BackendSDK.prototype.DocumentHistories_ReverseChanges = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("document-histories", args, { method: "post", route: "/ReverseChanges" })];
            });
        });
    };
    BackendSDK.prototype.ShortUrl_GetLongURL = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("short-url", args, { method: "post", route: "/GetLongURL" })];
            });
        });
    };
    BackendSDK.prototype.BankAccount_RunBankRelatedBot = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("bank-account", args, { method: "post", route: "/RunBankRelatedBot" })];
            });
        });
    };
    BackendSDK.prototype.BankAccount_UpdateBankAccountConfiguration = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("bank-account", args, { method: "post", route: "/UpdateBankAccountConfiguration" })];
            });
        });
    };
    BackendSDK.prototype.Notes_MarkStrikethroughNote = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cmsQuery("notes", args, { method: "post", route: "/MarkStrikethroughNote" })];
            });
        });
    };
    return BackendSDK;
}());
exports.BackendSDK = BackendSDK;
//# sourceMappingURL=BackendSDK.js.map